import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b10a255")

_pushScopeId("data-v-5b10a255")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "Microsoft Teams", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Retrieving data... ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamList = _resolveComponent("TeamList")
  const _component_TeamEditor = _resolveComponent("TeamEditor")
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.course == null)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.course && !_ctx.selected)
      ? (_openBlock(), _createBlock(_component_TeamList, {
          key: 1,
          course: _ctx.course,
          onEdit: _ctx.editTeam,
          canEdit: _ctx.canEdit,
          onSync: _ctx.sync
        }, null, 8, ["course", "onEdit", "canEdit", "onSync"]))
      : _createCommentVNode("", true),
    (_ctx.selected)
      ? (_openBlock(), _createBlock(_component_TeamEditor, {
          key: 2,
          course: _ctx.course,
          team: _ctx.selected,
          onDelete: _ctx.deleteSelected,
          canBecomeOwner: _ctx.canBecomeOwner,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected = null)),
          onSave: _cache[2] || (_cache[2] = ($event: any) => {_ctx.selected = null; _ctx.sync()})
        }, null, 8, ["course", "team", "onDelete", "canBecomeOwner"]))
      : _createCommentVNode("", true),
    (_ctx.isSyncing)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, {
          key: 3,
          text: "Synchronizing"
        }))
      : _createCommentVNode("", true)
  ], 64))
})